export enum FirestoreCollections {

    QRCODES = 'qrcodes',
    QRCODE_ORDERS = 'qrcode_orders',
    SETTINGS = 'settings',
    STORES = 'stores'
}